

























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import Ajax from "../../../lib/ajax";
@Component({
    components: {}
})
export default class OwnSpace extends AbpBase {
    get user() {
        return this.$store.state.session.user;
    }
    spinShow: boolean = false;
    created() {}
    async save() {
        (this.$refs.userForm as any).validate(async (valid: boolean) => {
            if (valid) {
                let postData = {
                    name: this.user.name,
                    phoneNumber: this.user.phoneNumber
                };
                this.spinShow = true;
                let rep = await Ajax.put(
                    "/api/services/app/User/UpdateProfile",
                    postData
                );
                setTimeout(() => {
                    this.$store.dispatch("session/init");
                }, 3000);
                this.spinShow = false;
                this.$Message.success(
                    this.L(
                        "UpdateSuccessMessage",
                        undefined,
                        this.L("UserProfile")
                    )
                );
            }
        });
    }
    userRule = {
        name: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("SupplierName")
                ),
                trigger: "blur"
            }
        ],
        phoneNumber: [
            {
                required: true,
                message: this.L(
                    "FieldIsRequired",
                    undefined,
                    this.L("MobileNumber")
                ),
                trigger: "blur"
            },
            {
                pattern: /^1[3456789]\d{9}$/,
                message: this.L(
                    "IncorrectFormat",
                    undefined,
                    this.L("MobileNumber")
                ),
                trigger: "blur"
            }
        ]
    };
}
